// @vendors
const { isEmpty } = require('lodash');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const { CHECK_LEGALES_ENABLED } = require('constants/flagBasedFeatures');

const reset = () => ({
    type: actionTypes.TERMS_AND_CONDS_RESET,
});

const termsAndCondsInfoRequest = () => ({
    type: actionTypes.TERMS_AND_CONDS_REQUEST,
});

const termsAndCondsInfoSuccess = () => ({
    type: actionTypes.TERMS_AND_CONDS_SUCCESS,
});

const termsAndCondsInfoFailure = (error, contractType) => ({
    type: actionTypes.TERMS_AND_CONDS_FAILURE,
    payload: {
        error,
        contractType
    }
});

const setTermsAndCondsText = text => ({
    type: actionTypes.TERMS_AND_CONDS_SET_TEXT,
    payload: {
        text,
    }
});

const setTermsAndCondsInfo = (contractType, products, operationProcessId = null) => (dispatch, getState) => {
    const termsAndCondsCountryFlags = getState().flagBasedFeatures.get(CHECK_LEGALES_ENABLED);
    const text = getState().termsAndCondsInfo.get('text');
    const immTermsAndConds = getState().termsAndCondsLegalWindow;
    const contractualAlias = immTermsAndConds.get('contractualAccountAlias');
    if (termsAndCondsCountryFlags && !!text && !!contractType && !isEmpty(products)) {
        dispatch(termsAndCondsInfoRequest());

        const requestData = {
            query: {
                productName: contractualAlias ? contractualAlias : contractType,
                productsHired: products,
                textChecked : text,
            },
        };
        
        if (!!operationProcessId) {
            requestData.query = {...requestData.query, operationProcessId }
        }

        return APIPost({
                dispatch,
                endpoint: 'termsAndConds',
                params: requestData,
            })
            .then(() => dispatch(termsAndCondsInfoSuccess()))
            .catch(response => {
                if (!!response.error) {
                    dispatch(termsAndCondsInfoFailure(response.error, contractType));
                } else {
                    throw response;
                }
            }
        );
    }
};

module.exports = {
    reset,
    setTermsAndCondsInfo,
    setTermsAndCondsText,
};
